// One-shot draft handoff for Financial Verticals ("Use settings" / Edit criteria).
// sessionStorage (not sticky localStorage) so a normal browser refresh starts clean.
import type { FinancialVerticalsForm } from '@/types';

export const FV_DRAFT_KEY = 'quralyst:draft:financial_verticals';

export const financialVerticalsDefaults: FinancialVerticalsForm = {
  targetDescription: '',
  businessType: '',
  continent: '',
  country: '',
  state: '',
  industry: '',
  subIndustry: '',
  useCustomIndustry: false,
  industryCustom: '',
  subIndustryCustom: '',
  revenueMin: '',
  revenueMax: '',
  ebitdaMin: '',
  ebitdaMax: '',
  equityCheckMin: '',
  equityCheckMax: '',
  enterpriseValueMin: '',
  enterpriseValueMax: '',
  targetRevenue: '',
  targetEbitda: '',
  platformEbitdaFloor: '',
  platformRevenueFloor: '',
  currentPortfolio: true,
  pastPortfolio: false,
  listedInterest: false,
  requestPeContact: false,
  autoEnrich: false,
};

export function stashFinancialDraft(values: unknown): void {
  try {
    sessionStorage.setItem(FV_DRAFT_KEY, JSON.stringify(values));
    localStorage.removeItem(FV_DRAFT_KEY);
  } catch {
    /* ignore */
  }
}

export function loadFinancialDraft(): FinancialVerticalsForm {
  try {
    localStorage.removeItem(FV_DRAFT_KEY);
    const raw = sessionStorage.getItem(FV_DRAFT_KEY);
    if (!raw) return financialVerticalsDefaults;
    sessionStorage.removeItem(FV_DRAFT_KEY);
    return {
      ...financialVerticalsDefaults,
      ...(JSON.parse(raw) as Partial<FinancialVerticalsForm>),
    };
  } catch {
    return financialVerticalsDefaults;
  }
}

export function clearFinancialDraft(): void {
  try {
    localStorage.removeItem(FV_DRAFT_KEY);
    sessionStorage.removeItem(FV_DRAFT_KEY);
  } catch {
    /* ignore */
  }
}
